import http from '@/utils/http'
import { logError } from '@/utils/logger'

const initialState = () => ({
  list: [],
  jobId: null
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LIST (state, list) {
    state.list = list
  },
  UPDATE_LIST_ITEM (state, { item, key, value }) {
    state.list = state.list.map(doc => {
      if (doc.ID === item.ID) {
        doc[key] = value
      }

      return doc
    })
  }
}

export const getters = {
  list: state => state.list
}

export const actions = {
  fetchDocuments ({ state, commit, rootGetters }, { jobId, force = false }) {
    if (!force && state.list.length && state.jobId === jobId) {
      return state.list
    }

    return http({
      url: `${process.env.VUE_APP_API_URL}jobdocumentsbyjob/${rootGetters['auth/token']}/${jobId}`
    }).then(data => {
      commit('SET_LIST', data)

      return data
    }).catch(e => {
      logError(e, { jobId }, 'record: error loading job documents')

      throw e
    })
  },
  saveDocument ({ rootGetters }, item) {
    item.CustomerID = rootGetters['customers/customer'].ID

    return http({
      method: 'post',
      url: `${process.env.VUE_APP_API_URL}jobdocument/save/${rootGetters['auth/token']}`,
      data: item
    }).catch(e => {
      logError(e, { item }, 'record: error saving job document')

      throw e
    })
  },
  removeDocument ({ rootGetters }, documentId) {
    return http({
      url: `${process.env.VUE_APP_API_URL}jobdocument/delete/${rootGetters['auth/token']}/${documentId}`
    }).catch(e => {
      logError(e, { documentId }, 'record: error removing job document')

      throw e
    })
  }
}
